<!--
    @修改人：黎柏祺
    @修改时间：2018-12-20
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @修改人：黎柏祺
    @修改时间：2018-04-20
    @修改描述：增加告警编码查询字段
    @版本:v1.0.16
    -------------------------------
    @description 告警查询
    @author xiehan
    @date 2018/9/19
-->
<template>
  <div class="alarmQuery__content">
    <el-tabs type="border-card"
      @tab-click="tabChange">
      <el-tab-pane :label="$t('alarmQuery.currentAlarm')">
        <div class="alarmQuery__currentAlarm pb15"
          style="overflow: visible">
          <describe-block :list="infoList"></describe-block>
        </div>
        <div class="alarmQuery__form">
          <el-form ref="form"
            :model="form"
            :inline="true"
            input-width="200px">
            <el-form-item :label="$t('alarmQuery.alarmType')">
              <g-select :list="alarmTypeList"
                :defaultAll="defaultAll"
                v-model="form.alarmType"></g-select>
            </el-form-item>
            <el-form-item :label="$t('alarmQuery.alarmLevel')">
              <g-select :list="alarmLevelList"
                :defaultAll="defaultAll"
                v-model="form.alarmLevel"></g-select>
            </el-form-item>
            <el-form-item :label="$t('alarmQuery.startTime')"
              input-width="480px">
              <el-date-picker v-model="form.startTime"
                type="datetime"
                value-format="timestamp">
              </el-date-picker>
              {{$t('common.to')}}
              <el-date-picker v-model="form.endTime"
                type="datetime"
                value-format="timestamp">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                @click="search"
                v-g-rac="gRac('alarmQueryCurrent_search')">{{ $t('common.search') }}</el-button>
              <el-button type="primary"
                @click="e_multiHandle_save"
                v-g-rac="gRac('alarmQueryCurrent_handle')">{{ $t('alarmQuery.multiHandle') }}</el-button>
            </el-form-item>
          </el-form>
          <!-- <el-button type="primary" @click="e_export(1)" v-g-rac="gRac('alarmQueryCurrent_export')">{{ $t('alarmQuery.export') }}</el-button> -->
          <el-table-extend :selection="true"
            :data="tData"
            :head="tableHead"
            :currentChange="currentChange"
            :sizeChange="sizeChange"
            :selectionChange="selectionChange"
            border>
            <template slot="control-column"
              slot-scope="{data}">
              <el-table-extend-control :control="tableControl"
                :data="data"
                :label="$t('common.handle')">
              </el-table-extend-control>
            </template>
          </el-table-extend>
        </div>
        <dialog-form key="alarmDatail"
          :title="$t('alarmQuery.alarmDetail')"
          :size="2"
          :label-size="2"
          :visible.sync="dialogFormShow"
          :model="dialogModel"
          :input-data="dialogData"
          :confirm-fun="e_handle_save"
          :confirm-label="$t('alarmQuery.handle')">
        </dialog-form>
      </el-tab-pane>
      <el-tab-pane :label="$t('alarmQuery.historyAlarm')">
        <div class="alarmQuery__form">
          <el-form ref="hisForm"
            :model="hisForm"
            :inline="true"
            input-width="200px">
            <el-form-item :label="$t('alarmQuery.alarmType')">
              <g-select :list="alarmTypeList"
                :defaultAll="defaultAll"
                v-model="hisForm.alarmType"></g-select>
            </el-form-item>
            <el-form-item :label="$t('alarmQuery.alarmLevel')">
              <g-select :list="alarmLevelList"
                :defaultAll="defaultAll"
                v-model="hisForm.alarmLevel"></g-select>
            </el-form-item>
            <el-form-item :label="$t('alarmQuery.alarmObject')">
              <el-input v-model="hisForm.alarmObject"></el-input>
            </el-form-item>
            <el-form-item :label="$t('alarmQuery.alarmAddress')">
              <el-input v-model="hisForm.alarmAddress"></el-input>
            </el-form-item>
            <el-form-item :label="$t('alarmQuery.startTime')"
              input-width="480px">
              <el-date-picker v-model="hisForm.startTime"
                type="datetime"
                value-format="timestamp">
              </el-date-picker>
              {{$t('common.to')}}
              <el-date-picker v-model="hisForm.endTime"
                type="datetime"
                value-format="timestamp">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                @click="e_hisSearch"
                v-g-rac="gRac('alarmQueryCurrent_search')">{{ $t('common.search') }}</el-button>
              <el-button type="primary"
                @click="e_export(2)"
                v-g-rac="gRac('alarmQueryCurrent_export')">{{ $t('alarmQuery.export') }}</el-button>
            </el-form-item>
          </el-form>
          <el-table-extend :data="tHisData"
            :head="hisTableHead"
            :currentChange="hisCurrentChange"
            :sizeChange="hisSizeChange"
            border>
            <template slot="control-column"
              slot-scope="{data}">
              <el-table-extend-control :control="hisTableControl"
                :data="data"
                :label="$t('common.handle')">
              </el-table-extend-control>
            </template>
          </el-table-extend>
        </div>
        <dialog-detail key="hostDetail"
          :title="$t('alarmQuery.alarmDetail')"
          :size="2"
          :label-size="2"
          :visible.sync="dialogDetailShow"
          :model="dialogDetailModel"
          :detail-data="dialogDataForDetail">
        </dialog-detail>
      </el-tab-pane>
      <el-tab-pane :label="$t('alarmQuery.timelyRate')">
        <timely-comp :show-chart="showEcharts"></timely-comp>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import dic from "@/components/mixins/dic";
import table from "@/components/mixins/table";
import exportTips from "@/components/mixins/exportTips";
import dialogForm from "@/components/dialogForm";
import dialogDetail from "@/components/dialogDetail";
import alarmQueryBiz from "@/logic/intelligentMonitor/alarmQueryBiz.js";
import describeBlock from "../component/alarmQuery/describeBlock";
import timelyComp from "../component/alarmQuery/timelyComp"; //处理及时率模板
import rac from "@/plugins/rac-mixin.js";
import TimeFormat from "@/utils/timeFormat.js";
import { extend } from "@/utils/tool.js";
import SiteListBiz from "@/logic/cmdb/cmdbBiz";

const DIC_MAP = {
  alarmType: "alarmType",
  alarmLevel: "alarmLevel"
};
export default {
  mixins: [dic, table, rac, exportTips],
  data() {
    const that = this;
    return {
      defaultAll: true,
      form: {
        siteCode: "",
        alarmType: "",
        alarmLevel: "",
        startTime: "",
        endTime: ""
      },
      hisForm: {
        alarmType: "",
        alarmLevel: "",
        alarmObject: "",
        alarmAddress: "",
        startTime: "",
        endTime: ""
      },
      currentPage: 1,
      perPageCount: 10,
      tableControl: [
        {
          label: that.$t("common.check"),
          callback: that.e_check,
          rac: () => that.gRac("alarmQueryCurrent_check")
        }
      ],
      hisCurrentPage: 1,
      hisPerPageCount: 10,
      hisTableControl: [
        {
          label: that.$t("common.check"),
          callback: that.e_hisCheck,
          rac: () => that.gRac("alarmQueryCurrent_check")
        }
      ],
      infoList: [],
      infoTotalCount: "",
      infoCurrentCount: "",
      infoLastTime: "",
      alarmTypeList: {},
      alarmLevelList: {},
      select_site: {},
      selection: [],
      triggertypeList: {},
      tableHead: [],
      hisTableHead: [],
      mode: "0",
      dialogFormShow: false,
      dialogDetailShow: false,
      dialogData: [],
      dialogDataForDetail: [],
      dialogModel: {
        processPlan: "",
        locationInfo: "",
        advise: ""
      },
      dialogDetailModel: {},
      selectAlarm: "",
      tHisData: {},
      doExport: null,
      showEcharts: false
    };
  },
  components: {
    describeBlock,
    dialogForm,
    dialogDetail,
    timelyComp
  },
  methods: {
    getSiteList() {
      SiteListBiz.siteList({ perPageCount: 500 }).then(data => {
        let list = {};
        data.dataList.map(item => {
          list[item.siteCode] = item.name;
        });
        this.select_site = list;
        this.waitAlarmTypeList();
        this.waitAlarmLevelList();
        this.waitTriggerTypeList();
      });
    },
    setDialogData() {
      let setData = [
        {
          label: this.$t("alarmQuery.alarmName"),
          key: "alarmName",
          disabled: true
        },
        {
          label: this.$t("alarmQuery.alarmType"),
          key: "alarmType",
          disabled: true
        },
        {
          label: this.$t("alarmQuery.trgType"),
          key: "trgType",
          disabled: true
        },
        {
          label: this.$t("alarmQuery.alarmObject"),
          key: "alarmObject",
          disabled: true
        },
        {
          label: this.$t("alarmQuery.alarmCode"),
          key: "alarmCode",
          disabled: true
        },
        {
          label: this.$t("alarmQuery.alarmAddress"),
          key: "alarmAddress",
          disabled: true
        },
        {
          label: this.$t("alarmQuery.alarmDesc"),
          key: "alarmContent",
          disabled: true
        },
        {
          label: this.$t("alarmQuery.alarmTime"),
          key: "alarmTime",
          disabled: true
        },
        {
          label: this.$t("alarmQuery.continueTime"),
          key: "continueTime",
          disabled: true
        },
        {
          label: this.$t("alarmQuery.processPlan"),
          key: "processPlan",
          type: "textarea",
          disabled: false
        },
        {
          label: this.$t("alarmQuery.alartInfo"),
          key: "locationInfo",
          type: "textarea",
          disabled: false
        },
        {
          label: this.$t("alarmQuery.advise"),
          key: "advise",
          type: "textarea",
          disabled: false
        }
      ];

      extend(true, this.dialogData, setData);
      this.dialogData.forEach(item => {
        this.dialogModel[item.key] = "";
      });

      extend(true, this.dialogDataForDetail, setData);
      [
        "alarmLevel",
        "alarmElement",
        "operator",
        "alarmSource",
        "recoverTime"
      ].forEach(key => {
        this.dialogDataForDetail.splice(8, 0, {
          label: this.$t(`alarmQuery.table.${key}`),
          disabled: true,
          key: key
        });
      });
      this.dialogDataForDetail.forEach(item => {
        this.dialogDetailModel[item.key] = "";
      });
    },
    init() {
      this.setDialogData();
      this.getSiteList();
    },
    initTable() {
      this.tableHead = [
        { key: "alarmCode", label: this.$t("alarmQuery.table.alarmCode") },
        {
          key: "siteCode",
          label: this.$t("alarmQuery.table.siteCode"),
          showOverflowTooltip: true,
          formatter: "Dictionary",
          formatterDic: this.select_site
        },
        {
          key: "alarmName",
          label: this.$t("alarmQuery.table.alarmName"),
          showOverflowTooltip: true
        },
        {
          key: "alarmType",
          label: this.$t("alarmQuery.table.alarmType"),
          formatter: "Dictionary",
          formatterDic: this.alarmTypeList
        },
        { key: "alarmObject", label: this.$t("alarmQuery.table.alarmObject") },
        {
          key: "alarmAddress",
          label: this.$t("alarmQuery.table.alarmAddress")
        },
        {
          key: "alarmLevel",
          label: this.$t("alarmQuery.table.alarmLevel"),
          formatter: "Dictionary",
          formatterDic: this.alarmLevelList
        },
        {
          key: "alarmContent",
          label: this.$t("alarmQuery.table.alarmContent"),
          showOverflowTooltip: true
        },
        { key: "alarmTime", label: this.$t("alarmQuery.table.alarmTime") },
        { key: "continueTime", label: this.$t("alarmQuery.table.continueTime") }
      ];
      this.hisTableHead = [
        { key: "alarmCode", label: this.$t("alarmQuery.table.alarmCode") },
        {
          key: "alarmName",
          label: this.$t("alarmQuery.table.alarmName"),
          showOverflowTooltip: true
        },
        {
          key: "alarmLevel",
          label: this.$t("alarmQuery.table.alarmLevel"),
          formatter: "Dictionary",
          formatterDic: this.alarmLevelList
        },
        {
          key: "alarmType",
          label: this.$t("alarmQuery.table.alarmType"),
          formatter: "Dictionary",
          formatterDic: this.alarmTypeList
        },
        {
          key: "alarmElement",
          label: this.$t("alarmQuery.table.alarmElement")
        },
        {
          key: "alarmAddress",
          label: this.$t("alarmQuery.table.alarmAddress")
        },
        {
          key: "alarmContent",
          label: this.$t("alarmQuery.table.alarmContent"),
          showOverflowTooltip: true
        },
        { key: "alarmSource", label: this.$t("alarmQuery.table.alarmSource") },
        { key: "alarmTime", label: this.$t("alarmQuery.table.alarmTime") },
        { key: "recoverTime", label: this.$t("alarmQuery.table.recoverTime") },
        { key: "operator", label: this.$t("alarmQuery.table.operator") }
      ];
    },
    e_getCount() {
      alarmQueryBiz.info().then(data => {
        this.infoTotalCount = data.allAlarmCount;
        this.infoCurrentCount = data.todayAlarmCount;
        this.infoLastTime = TimeFormat.getAutoFormatTime(data.lastTime);
        this.infoList = [
          {
            num: this.infoTotalCount,
            title: this.$t("alarmQuery.currentAlarmCount")
          },
          {
            num: this.infoCurrentCount,
            title: this.$t("alarmQuery.todayAlarmCount")
          },
          {
            num: this.infoLastTime,
            title: this.$t("alarmQuery.maxRetentionTime")
          }
        ];
      });
    },
    async waitAlarmTypeList() {
      await this.dGetDictionaryByCode("alarmType");
      this.alarmTypeList = { ...this.dDictionary.alarmType };
    },
    async waitTriggerTypeList() {
      await this.dGetDictionaryByCode("triggertype");
      this.triggertypeList = { ...this.dDictionary.triggertype };
    },
    async waitAlarmLevelList() {
      await this.dGetDictionaryByCode("alarmLevel");
      this.alarmLevelList = { ...this.dDictionary.alarmLevel };
      setTimeout(() => {
        this.initTable();
        this.search();
        this.hisSearch();
      }, 200);
    },
    currentChange(data) {
      this.currentPage = data;
      this.e_search();
    },
    sizeChange(data) {
      this.currentPage = 1;
      this.perPageCount = data;
      this.e_search();
    },
    hisCurrentChange(data) {
      this.hisCurrentPage = data;
      this.e_hisSearch();
    },
    hisSizeChange(data) {
      this.hisCurrentPage = 1;
      this.hisPerPageCount = data;
      this.e_hisSearch();
    },
    search() {
      this.currentPage = 1;
      this.e_search();
    },
    e_search() {
      this.e_getCount();
      let d = {
        ...this.form,
        currentPage: this.currentPage,
        perPageCount: this.perPageCount
      };
      Object.keys(this.form).forEach(item => {
        if (this.form[item] === "") {
          delete d[item];
        }
      });
      alarmQueryBiz.query(d).then(data => {
        data.dataList.forEach(item => {
          Object.keys(item).map(function(keyItem, keyIndex, keyArray) {
            if (keyItem === "continueTime") {
              item[keyItem] = TimeFormat.millisecondToDate(item[keyItem]);
            }
            if (keyItem === "alarmTime") {
              item[keyItem] = TimeFormat.getFormatTime(item[keyItem]);
            }
          });
        });
        this.tData = data;
      });
    },
    hisSearch() {
      this.hisCurrentPage = 1;
      this.e_hisSearch();
    },
    e_hisSearch() {
      let d = {
        ...this.hisForm,
        currentPage: this.hisCurrentPage,
        perPageCount: this.hisPerPageCount
      };
      Object.keys(this.hisForm).forEach(item => {
        if (this.hisForm[item] === "") {
          delete d[item];
        }
      });
      alarmQueryBiz.queryHistory(d).then(data => {
        data.dataList.forEach(item => {
          Object.keys(item).map(function(keyItem, keyIndex, keyArray) {
            if (keyItem === "continueTime") {
              item[keyItem] = TimeFormat.millisecondToDate(item[keyItem]);
            }
            if (keyItem === "recoverTime") {
              item[keyItem] = TimeFormat.getFormatTime(item[keyItem]);
            }
            if (keyItem === "alarmTime") {
              item[keyItem] = TimeFormat.getFormatTime(item[keyItem]);
            }
            if (keyItem === "processTime") {
              item[keyItem] = TimeFormat.getFormatTime(item[keyItem]);
            }
          });
        });
        this.tHisData = data;
      });
    },
    e_multiHandle_save() {
      let data = [];
      if (this.selection.length === 0) {
        this.$message({
          message: this.$t("alarmQuery.unSelected"),
          type: "warning"
        });
        return;
      }
      this.selection.forEach(item => data.push(item.id));
      alarmQueryBiz.handle({ id: data }).then(res => {
        this.$message({
          message: this.$t("common.success"),
          type: "success"
        });
        setTimeout(() => {
          this.search();
        }, 500);
      });
    },
    e_export(n) {
      const search = n === 1 ? extend({}, this.form) : extend({}, this.hisForm);
      this.doExport = this.exportTable(n);
      this.doExport(search);
    },
    exportTable(n) {
      const that = this;
      const dictionary = [];
      const list = this[n === 1 ? "tableHead" : "hisTableHead"].reduce(
        (res, item) => {
          res[item.key] = item.label;
          return res;
        },
        {}
      );
      for (const key in DIC_MAP) {
        dictionary.push({
          relate: key,
          type: that.dDictionary[DIC_MAP[key]]
        });
      }
      return function(search) {
        that.exRenderBefore();
        if (n === 1) {
          alarmQueryBiz.exportCurrentAlarm(
            list,
            search,
            ["alarmTime", "continueTime"],
            dictionary,
            that.exRenderTips,
            that.exRenderFail
          );
        } else {
          alarmQueryBiz.exportHistoryAlarm(
            list,
            search,
            ["alarmTime", "continueTime", "recoverTime"],
            dictionary,
            that.exRenderTips,
            that.exRenderFail
          );
        }
      };
    },
    e_handle_save(d) {
      let data = {
        id: this.selectAlarm
      };
      if (d.processPlan !== "") data.processPlan = d.processPlan;
      if (d.advise !== "") data.advise = d.advise;
      if (d.locationInfo !== "") data.locationInfo = d.locationInfo;
      alarmQueryBiz.singleHandle(data).then(res => {
        this.dialogFormShow = false;
        this.$message({
          message: this.$t("common.success"),
          type: "success"
        });
        setTimeout(() => {
          this.search();
        }, 500);
      });
    },
    e_check(d) {
      this.dialogFormShow = true;
      Object.keys(this.dialogModel).forEach(item => {
        this.dialogModel[item] =
          item === "trgType" ? this.triggertypeList[d[item]] : d[item];
      });
      this.selectAlarm = d.id;
    },
    e_hisCheck(d) {
      this.dialogDetailShow = true;
      Object.keys(this.dialogDetailModel).forEach(item => {
        this.dialogDetailModel[item] =
          item === "trgType" ? this.triggertypeList[d[item]] : d[item];
      });
    },
    selectionChange(d) {
      this.selection = d;
    },
    tabChange(e) {
      this.mode = e.index;
      if (e.index === "2") {
        this.showEcharts = true;
      } else {
        this.showEcharts = false;
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style>
.alarmQuery__content ul li {
  list-style: none;
}
.alarmQuery__flexBox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
.alarmQuery__ilb {
  display: inline-block;
  width: 49.5%;
  vertical-align: top;
}
.alarmQuery__flexBox--left {
  margin-top: 40px;
  width: 32.3%;
}
.alarmQuery__flexBox--right {
  margin-top: 5px;
  width: 66%;
}
.alarmQuery__flexBox--text {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  padding: 6px;
}
.pb15 {
  padding-bottom: 15px;
}
</style>
